import { authFetch } from "./auth-fetch"

export type FetchClientProps = {
  url: string
  options?: RequestInit
}

export async function storeSessionTokens(accessToken: string, refreshToken?: string) {
  // No-op client-side: cookies are managed by NestJS and browser natively,
  // and accessToken is managed in-memory in auth-fetch.ts.
}

export async function clearSessionCookies() {
  // No-op client-side: handled on backend logout.
}

export async function fetchClient({ url, options }: FetchClientProps) {
  // Delegate directly to client-side authFetch which handles in-memory tokens & auto-refresh
  return authFetch(url, options)
}
